import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  buttonGroup: FelaCSS;
  contentWrapper: FelaCSS;
  imageWrapper: FelaCSS;
  text: FelaCSS;
  title: FelaCSS;
  wrapper: FelaCSS;
}

export const styles: IStyles = {
  buttonGroup: {
    gap: spacing[4],
    minWidthDesktop: {
      flexDirection: 'row-reverse',
    },
  },
  contentWrapper: {
    gap: spacing[4],
    paddingTop: spacing[12],
  },
  imageWrapper: {
    alignItems: 'center',
  },
  text: {
    fontDefault: 16,
    color: colors.space,
    textWrap: 'pretty',
    minWidthDesktop: {
      // @ts-expect-error text-wrap is a valid css property https://caniuse.com/?search=text-wrap
      textWrap: 'balance',
    },
  },
  title: {
    fontPlayfair: 28,
    color: colors.space,
    textWrap: 'pretty',
    minWidthDesktop: {
      // @ts-expect-error text-wrap is a valid css property https://caniuse.com/?search=text-wrap
      textWrap: 'balance',
    },
  },
  wrapper: {
    textAlign: 'center',
    gap: spacing[6],
    paddingTop: spacing[8],
    paddingHorizontal: spacing[6],
    paddingBottom: spacing[6],
    width: '100%',
    maxWidth: '343px',
    minWidthDesktop: {
      width: '600px',
      maxWidth: '600px',
    },
  },
};
